import { render } from "./stronaKontakt.vue?vue&type=template&id=08d05fa3&scoped=true"
import script from "./stronaKontakt.vue?vue&type=script&lang=js"
export * from "./stronaKontakt.vue?vue&type=script&lang=js"

import "./stronaKontakt.vue?vue&type=style&index=0&id=08d05fa3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d05fa3"]])

export default __exports__